import { useMemo, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Row, Col, Form } from 'antd';

import MultistepFormActions from '@/components/MultistepFormActions';
import { actions } from '@/redux/tour/cruise/reducer';

import Steps from './Steps';
import GeneralDetails from './GeneralDetails';
import ShipDetails from './ShipDetails';
import CruiseItenerary from './CruiseItenerary';
import InclusionsExclusions from './InclusionsExclusions';

const formSteps = [
    GeneralDetails,
    ShipDetails,
    CruiseItenerary,
    InclusionsExclusions,
];

const New = ({ isEdit = false }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    // const { push } = useHistory();

    const { id: urlId } = useParams();
    const reduxId = useSelector((state) => state.tour.cruise.create.generalInfo?.id);
    const regStep = useSelector((state) => state.tour.cruise.create
        .generalInfo?.tour_register_step);

    const step = useSelector((state) => state.tour.cruise.create.step);

    const id = useMemo(() => {
        return isEdit ? urlId : reduxId;
    }, [isEdit, urlId, reduxId]);
    const submitting = useSelector(
        (state) => state.tour.cruise.create.submitting,
    );

    const goToStep = useCallback((s) => {
        dispatch(actions.goToCreateCruiseStep(s));
    }, [dispatch]);

    const FormStepComponent = useMemo(() => {
        if (step >= 0 && step < formSteps.length) {
            // push(`/app/tours/cruise/${id}/edit`);
            return formSteps[step];
        } else if (formSteps.length === step) {
            // push(`/app/tours/cruise/${id}/edit`);
            return formSteps[formSteps.length - 1];
        } else {
            return formSteps[0];
        }
    }, [step]);

    useEffect(() => {
        if (isEdit && id) {
            dispatch(actions.requestFetchCruiseData(id));
        }
    }, [isEdit, dispatch, id]);

    return (
        <Row id="add-cruise-tour-page" gutter={[30, 30]}>
            <Col
                lg={{ span: 14, order: 1 }}
                xs={{ span: 24, order: 2 }}
            >
                <div className="left-col">
                    <FormStepComponent
                        form={form}
                        id={id}
                        regStep={regStep}
                        isEdit={isEdit}
                    />
                </div>
            </Col>

            <Col
                lg={{ span: 10, order: 2 }}
                xs={{ span: 24, order: 1 }}
            >
                <div className="right-col-container">
                    <div className="right-col">
                        <Steps step={step} />
                    </div>
                    <MultistepFormActions
                        stepCount={4}
                        step={step}
                        submitting={submitting}
                        onSubmit={() => {
                            form.submit();
                        }}
                        onBack={() => goToStep(step - 1)}
                        viewOneUrl={
                            (id !== undefined)
                                ? `/app/tours/cruise/${id}`
                                : undefined
                        }
                        viewOneButtonText="View this cruise"
                        viewAllUrl="/app/tours/cruise/"
                        createUrl="/app/tours/cruise/add/"
                        onPublish={console.log}
                    />
                </div>
            </Col>
        </Row>
    );
};

export default New;
